import { render } from "./AICompressionOrder.vue?vue&type=template&id=8b68c548&scoped=true"
import script from "./AICompressionOrder.vue?vue&type=script&lang=js"
export * from "./AICompressionOrder.vue?vue&type=script&lang=js"

import "./AICompressionOrder.vue?vue&type=style&index=0&id=8b68c548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b68c548"]])

export default __exports__